var map = {
	"./new-banking.jpg": "d17ba",
	"./offer1.jpg": "a95b",
	"./offer2.jpg": "3979",
	"./offer3.jpg": "1a02",
	"./offer4.jpg": "68b6",
	"./offer5.jpg": "5400"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94be";